import {
  Flex,
  Heading,
  Text,
  Box,
  Image,
  Grid,
  Button,
} from "@chakra-ui/react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { PrimaryButton } from "../../components/buttons";
import { SecondaryButton } from "../../components/buttons/SecondaryButton";
import { ModalContext } from "../../system/context/ModalContext";
import { useUiText } from "../../system/hooks/useUiText";
import {
  APP_HEADER_BACKGROUND_COLOR,
  APP_PRIMARY_CONTRAST_COLOR,
  APP_SECONDARY_COLOR,
} from "../../theme/colors";
import { steps } from "./utils";
import mixpanel from "mixpanel-browser";
import { AppContainer } from "../../layout/AppContainer/AppContainer";

const HomePage = () => {
  const { uiText } = useUiText();
  const { walletModal } = useContext(ModalContext);
  const navigate = useNavigate();

  const renderIntroSection = () => {
    return (
      <Flex
        justifyContent="center"
        bgColor={"white"}
        pb="50px"
        pt="50px"
        color={"black"}
      >
        <Flex
          flexDir="column"
          textAlign="center"
         justifyContent="center"
          alignItems="center"
        >
          <Heading
            fontFamily="heading"
            fontSize={{ base: "30px", md: "48px" }}
            fontWeight="bold"
          >
            {uiText.homePageTitle}
          </Heading>
          <Text
            fontSize={{ base: "14px", md: "24px" }}
            fontWeight="bold"
            mb="20px"
            maxW={{ base: "300px", md: "100%" }}
          >
            {uiText.homePageSubTitle1} <i>{uiText.homePageSubTitle2}</i>
          </Text>
          <Flex
            mt="10px"
            mb="10px"
            flexWrap={{ base: "wrap", sm: "wrap", md: "wrap" }}
            justifyContent="center"
            w="100%"
          >
            <Box
              boxShadow="-2px 0px 9px #dadada"
              w={{ base: "360px", md: "600px" }}
              h={{ base: "700px", md: "600px" }}
              borderRadius="8px"
              mr={{ base: "0px", md: "45px" }}
              p="20px"
              backgroundImage="url('/freemiumcropped.webp')"
              backgroundPosition="right"
              backgroundSize="contain"
              backgroundRepeat="no-repeat"
              mb={{ base: "10px", lg: "10px" }}
            >
              <Box bgColor="#ffffffb3" mr="-20px" h="100%">
                <Flex flexDir="column" alignItems="center">
                  <Heading>{uiText.freemium} </Heading>
                  <Text maxW="380px" fontSize={{ base: "14px" }}>
                    {uiText.freemiumSubTitle}
                  </Text>
                </Flex>
                <Flex flexDir="column" alignItems="flex-start">
                  <Flex alignItems="baseline">
                    <Text
                      fontFamily="heading"
                      fontSize="24px"
                      fontWeight="bold"
                      mr="5px"
                    >
                      0 ETH
                    </Text>
                    <Text> /licence</Text>
                  </Flex>
                  <Text>+ 2.5% per NFT minted</Text>
                </Flex>
                <Flex
                  flexDir="column"
                  mt="10px"
                  textAlign="left"
                  maxW={{ base: "300px", md: "450px" }}
                >
                  <Text fontWeight="bold">What’s Included in Freemium</Text>
                  {uiText.whatsIncludedInFreemium.map((l) => (
                    <Text key={l} fontSize="14px">
                      - {l}
                    </Text>
                  ))}
                </Flex>
                <SecondaryButton
                  text="Get Started"
                  borderColor="black"
                  mt="100px"
                  fontFamily={"heading"}
                  onClick={() => {
                    navigate("/freemium");
                    mixpanel.track("Navigate to Freemium");
                  }}
                />
              </Box>
            </Box>
            <Box
              padding="3px"
              borderRadius="8px"
              bgImage="linear-gradient(to top right, #ebd6a6, #d377ec, #67fde1);"
              mr={{ base: "0px", md: "45px" }}
              w={{ base: "360px", md: "600px" }}
              h={{ base: "max", md: "600px" }}
              mb="10px"
            >
              <Box
                boxShadow="xl"
                borderRadius="8px"
                p="20px"
                bgColor={APP_HEADER_BACKGROUND_COLOR}
                backgroundImage="url('/premiumcropped.webp')"
                backgroundPosition={{ base: "0% 10%", md: "right" }}
                backgroundSize="contain"
                backgroundRepeat="no-repeat"
                h="100%"
              >
                <Box bgColor="#1c171ac7" h="100%" mr="-20px">
                  <Flex flexDir="column" alignItems="center">
                    <Heading color={APP_SECONDARY_COLOR}>Premium </Heading>
                    <Text color={APP_PRIMARY_CONTRAST_COLOR} maxW="420px">
                      Advanced features for pros who need more customization.
                    </Text>
                  </Flex>
                  <Flex flexDir="column" alignItems="flex-start">
                    <Flex alignItems="baseline">
                      <Text
                        color={APP_PRIMARY_CONTRAST_COLOR}
                        fontFamily="heading"
                        fontSize="24px"
                        fontWeight="bold"
                        mr="5px"
                      >
                        5 ETH
                      </Text>
                      <Text color={APP_PRIMARY_CONTRAST_COLOR}>/licence</Text>
                    </Flex>
                    <Text color={APP_PRIMARY_CONTRAST_COLOR}>
                      0% per NFT minted
                    </Text>
                  </Flex>

                  <Flex
                    flexDir="column"
                    mt="10px"
                    textAlign="left"
                    maxW={{ base: "300px", md: "100%" }}
                  >
                    <Text color={APP_PRIMARY_CONTRAST_COLOR} fontWeight="bold">
                      Everything in Freemium, plus:
                    </Text>
                    {uiText.whatsIncludedInPremium.map((l) => (
                      <Text
                        key={l}
                        color={APP_PRIMARY_CONTRAST_COLOR}
                        fontSize="14px"
                      >
                        - {l}
                      </Text>
                    ))}
                  </Flex>
                  <PrimaryButton
                    text="Get Receipt"
                    mt="60px"
                    onClick={() => {
                      mixpanel.track("Navigate to Mint Receipt");
                      walletModal.onOpen();
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Flex>
        </Flex>
      </Flex>
    );
  };

  const renderWelcomeSection = () => {
    return (
      <Flex
        justifyContent="flex-start"
        backgroundImage="url('/welcomeomakaseabackground.webp')"
        backgroundSize="cover"
        h={{ base: "100%", md: "700px" }}
        position="relative"
        alignContent="flex-start"
      >
        <Flex flexDir="column">
          <Flex flexWrap={"wrap"}>
            <Flex
              flexDir="column"
              maxW={{ base: "370px", md: "370px", lg: "370px", xl: "570px" }}
              textAlign="left"
              ml={{ base: "50px", md: "50px", lg: "150px" }}
            >
              <Heading
                color={APP_PRIMARY_CONTRAST_COLOR}
                fontSize={{ base: "30px", md: "50px" }}
                mt="200px"
              >
                Welcome to Omakasea
              </Heading>

              <Text zIndex={2} color={APP_PRIMARY_CONTRAST_COLOR}>
                Omakasea is an all-in-one Generative and one of one NFT creation
                utility that makes it simple, fast, and affordable for artists,
                creative teams, agencies and developers to deploy unique,
                randomly-generated Generative NFT collections.
              </Text>
              <Button
                bgColor={"#1212128c"}
                _hover={{ opacity: 0.8 }}
                _focus={{
                  outlineColor: "transparent",
                }}
                display="flex"
                flexDir={"row"}
                w="130px"
                h="40px"
                mt="70px"
                onClick={() => window.open("/files/Lightpaper.pdf")}
              >
                <Image
                  src="/images/File.png"
                  srcSet="/images/File@2x.png 2x"
                  objectFit={"cover"}
                  w="13px"
                  h="17px"
                />
                <Text
                  fontFamily={"body"}
                  fontWeight="medium"
                  fontSize={"15px"}
                  color={APP_PRIMARY_CONTRAST_COLOR}
                  ml="9px"
                >
                  {uiText.lightPaper}
                </Text>
              </Button>
            </Flex>
            <Box>
              <Image
                h={{ base: "500px", lg: "600px" }}
                objectFit={"cover"}
                src="/welcometoomakasea.webp"
                position={{ base: "relative", md: "absolute" }}
                right="0"
              />
            </Box>
          </Flex>
        </Flex>
      </Flex>
    );
  };

  const renderStep = (img: string, step: number, text: string) => {
    return (
      <Flex
        key={step}
        flexDir="column"
        mb="20px"
        alignItems="flex-start"
        maxW="400px"
        justifyContent="center"
        color="black"
      >
        <Image src={img} maxH="400px" w="280px" mt="70px" />
        <Flex flexDir="column" mt="20px" maxW="300px">
          <Text
            fontFamily="heading"
            fontSize="30px"
            fontWeight="bold"
            alignItems="flex-start"
          >
            Step {step}
          </Text>
          <Text fontWeight="bold">{text}</Text>
        </Flex>
      </Flex>
    );
  };

  const renderMintingProcessSection = () => {
    return (
      <Flex justifyContent="center" bgColor="white" color="black">
        <Flex flexDir="column" maxW="1000px" mt="80px">
          <Text
            fontFamily="heading"
            fontSize={{ base: "30px", md: "48px" }}
            fontWeight="bold"
          >
            Omakasea’s Kitchen Minting Process
          </Text>
          <Text fontSize={{ base: "16px", md: "20px" }} fontWeight="normals">
            Here’s an introduction to show you just how easy & quick it is to
            deploy a Generative NFT Collection using Omakasea’s Kitchen.
          </Text>
          <Grid
            templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)" }}
            justifyItems="center"
            mb="100px"
          >
            <Flex flexDir="column" mb="20px" alignItems="center">
              <Image src="/step1.webp" maxH="400px" w="280px" />
              <Text
                fontFamily="heading"
                fontSize="30px"
                fontWeight="bold"
                alignItems="center"
                mt="-30px"
              >
                Step1
              </Text>
              <Flex flexDir="column" alignItems="flex-start">
                <Text fontWeight="bold" fontSize="18px">
                  Gather your ingredients
                </Text>

                {[
                  "- Image layers and rarity weights",
                  "- Custom Metadata",
                  "- Whitelisted addresses",
                  "- NFT Pricing",
                ].map((l) => (
                  <Text key={l} fontWeight="bold">
                    {l}
                  </Text>
                ))}
              </Flex>
            </Flex>
            {steps.map((s) => renderStep(s.img, s.step, s.text))}
          </Grid>
        </Flex>
      </Flex>
    );
  };

  const renderTeamSection = () => {
    return (
      <Flex
        justifyContent="center"
        backgroundImage="url('/teambackground.webp')"
        backgroundSize="cover"
      >
        <Flex flexDir="column">
          <Flex flexWrap={{ base: "wrap" }}>
            <Flex ml="20px" flexDir="column" maxW="570px" textAlign="left">
              <Heading
                color={APP_PRIMARY_CONTRAST_COLOR}
                fontSize={{ base: "30px", md: "50px" }}
                mt="200px"
              >
                About
              </Heading>
              <Heading
                color={APP_PRIMARY_CONTRAST_COLOR}
                fontSize={{ base: "30px", md: "50px" }}
              >
                the Omakasea Team
              </Heading>
              <Text color={APP_PRIMARY_CONTRAST_COLOR}>
                The Omakasea team is a group of DeFi devs and art enthusiasts
                who want to empower creators to make dynamic NFT collections
                without the need for costly devs or technical experience that
                can take years to acquire.
              </Text>
            </Flex>
            <Image
              h={{ base: "400px", md: "600px" }}
              w={{ base: "400px", md: "600px" }}
              src="/teamomakasea.webp"
            />
          </Flex>
        </Flex>
      </Flex>
    );
  };

  return (
    <AppContainer>
      <Flex flexDir="column" w="100%" bgColor={APP_HEADER_BACKGROUND_COLOR}>
        {renderIntroSection()}
        {/* {renderVideoDemoSection()} */}
        {renderWelcomeSection()}
        {renderMintingProcessSection()}
        {renderTeamSection()}
        {renderIntroSection()}
      </Flex>
    </AppContainer>
  );
};

export default HomePage;
